import axios from "axios";
import { API_URL } from "../apiConfig";

const authHeaders = () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("No token");
  return { Authorization: `Bearer ${token}` };
};

export const meetingMediaUrl = (fileUrl) => {
  if (!fileUrl) return "";
  if (/^(https?:|blob:|data:)/i.test(fileUrl)) return fileUrl;
  const base = String(API_URL || "").replace(/\/$/, "");
  return `${base}${fileUrl.startsWith("/") ? "" : "/"}${fileUrl}`;
};

export const listMeetingClientContacts = async (marca) => {
  const res = await axios.get(
    `${API_URL}/api/meeting-sessions/client-contacts`,
    {
      headers: authHeaders(),
      params: { marca: String(marca || "").trim() },
    },
  );
  return res.data;
};

export const listMeetingSessions = async () => {
  const res = await axios.get(`${API_URL}/api/meeting-sessions`, {
    headers: authHeaders(),
  });
  return res.data;
};

export const getMeetingSession = async (id) => {
  const res = await axios.get(`${API_URL}/api/meeting-sessions/${id}`, {
    headers: authHeaders(),
  });
  return res.data;
};

export const createMeetingSession = async (body = {}) => {
  const res = await axios.post(`${API_URL}/api/meeting-sessions`, body, {
    headers: authHeaders(),
  });
  return res.data;
};

export const patchMeetingSession = async (id, body) => {
  const res = await axios.patch(`${API_URL}/api/meeting-sessions/${id}`, body, {
    headers: authHeaders(),
  });
  return res.data;
};

export const stopMeetingSession = async (id) => {
  const res = await axios.post(
    `${API_URL}/api/meeting-sessions/${id}/stop`,
    {},
    { headers: authHeaders() },
  );
  return res.data;
};

export const uploadMeetingAudioChunk = async (
  id,
  file,
  { seq, durationMs } = {},
) => {
  const form = new FormData();
  form.append("file", file);
  if (seq != null) form.append("seq", String(seq));
  if (durationMs != null) form.append("durationMs", String(durationMs));
  const res = await axios.post(
    `${API_URL}/api/meeting-sessions/${id}/audio-chunks`,
    form,
    { headers: { ...authHeaders(), "Content-Type": "multipart/form-data" } },
  );
  return res.data;
};

export const uploadMeetingPhoto = async (
  id,
  file,
  { caption, offsetMs, capturedAt } = {},
) => {
  const form = new FormData();
  form.append("file", file);
  if (caption) form.append("caption", caption);
  if (offsetMs != null) form.append("offsetMs", String(offsetMs));
  if (capturedAt) form.append("capturedAt", capturedAt);
  const res = await axios.post(
    `${API_URL}/api/meeting-sessions/${id}/photos`,
    form,
    { headers: { ...authHeaders(), "Content-Type": "multipart/form-data" } },
  );
  return res.data;
};

export const patchMeetingPhoto = async (id, photoId, body) => {
  const res = await axios.patch(
    `${API_URL}/api/meeting-sessions/${id}/photos/${photoId}`,
    body,
    { headers: authHeaders() },
  );
  return res.data;
};

export const deleteMeetingPhoto = async (id, photoId) => {
  const res = await axios.delete(
    `${API_URL}/api/meeting-sessions/${id}/photos/${photoId}`,
    { headers: authHeaders() },
  );
  return res.data;
};

export const summarizeMeetingSession = async (id) => {
  const res = await axios.post(
    `${API_URL}/api/meeting-sessions/${id}/summarize`,
    {},
    { headers: authHeaders(), timeout: 2700000 },
  );
  return res.data;
};

/** Escaneo en reunión: movimiento a cliente + Sent to Client + leftWithClient. */
export const leaveMeetingSamples = async (
  id,
  { samples, ID_CLIENTE, ID_CONTACTO, PERSONA_ENVIO, NUM_COURIER, FECHA_ENVIO },
) => {
  const res = await axios.post(
    `${API_URL}/api/meeting-sessions/${id}/leave-samples`,
    {
      samples,
      ID_CLIENTE,
      ID_CONTACTO,
      PERSONA_ENVIO,
      NUM_COURIER,
      FECHA_ENVIO,
    },
    { headers: authHeaders() },
  );
  return res.data;
};

export const createMeetingFreeNote = async (id, body) => {
  const res = await axios.post(
    `${API_URL}/api/meeting-sessions/${id}/notes`,
    { body },
    { headers: authHeaders() },
  );
  return res.data;
};

export const patchMeetingFreeNote = async (id, noteId, body) => {
  const res = await axios.patch(
    `${API_URL}/api/meeting-sessions/${id}/notes/${noteId}`,
    { body },
    { headers: authHeaders() },
  );
  return res.data;
};

export const deleteMeetingFreeNote = async (id, noteId) => {
  await axios.delete(`${API_URL}/api/meeting-sessions/${id}/notes/${noteId}`, {
    headers: authHeaders(),
  });
};

export const claimMeetingRecording = async (id) => {
  const res = await axios.post(
    `${API_URL}/api/meeting-sessions/${id}/recording/claim`,
    {},
    { headers: authHeaders() },
  );
  return res.data;
};

export const releaseMeetingRecording = async (id, { force = false } = {}) => {
  const res = await axios.post(
    `${API_URL}/api/meeting-sessions/${id}/recording/release`,
    { force },
    { headers: authHeaders() },
  );
  return res.data;
};

export const deleteMeetingSession = async (id) => {
  const res = await axios.delete(`${API_URL}/api/meeting-sessions/${id}`, {
    headers: authHeaders(),
  });
  return res.data;
};
